@if (((newsResource.value()?.newsArticles) ?? []).length > 0) {
<mat-card class="info-panel">
  <mat-card-header>
    <mat-card-title>
      <span>Aktuelle Nachrichten</span>
      <!-- <button mat-icon-button><mat-icon class="material-icons-outlined">info</mat-icon></button>  -->
    </mat-card-title>
  </mat-card-header>
  @for (newsItem of (newsResource.value()?.newsArticles); track newsItem.xid; let isLast = $last) {
  <mat-card-header>
    <mat-card-title>
      {{newsItem.tsPublished | date : 'longDate'}}
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    @if (newsItem.subject) {
    <div class="news-title">{{newsItem.subject}}</div>
    }
    <div>
      <markdown [data]="newsItem.content" />
    </div>
  </mat-card-content>
  @if (newsItem.url) {
   <mat-card-actions>
    <a matButton [href]="newsItem.url" target="_blank" class="large-link">{{newsItem.url}}</a>
   </mat-card-actions>
  }
  @if (!isLast) {
  <mat-divider></mat-divider>
  }
  }
</mat-card>
}